/* ============================================================
   Product Specifications Block — accordion behavior
   - Toggles .open on the .specs-group
   - Animates max-height of .group-content
   - Keeps open groups correctly sized on resize / image load
   ============================================================ */

(function () {
  'use strict';

  function setOpen(content, group) {
    content.style.maxHeight = content.scrollHeight + 'px';
    // After transition completes, release the cap so the group
    // can grow/shrink with responsive content.
    var onEnd = function (e) {
      if (e.propertyName !== 'max-height') return;
      if (group.classList.contains('open')) {
        content.style.maxHeight = 'none';
      }
      content.removeEventListener('transitionend', onEnd);
    };
    content.addEventListener('transitionend', onEnd);
  }

  function setClosed(content) {
    // Pin current height first so the transition has a starting point.
    content.style.maxHeight = content.scrollHeight + 'px';
    // Force reflow so the browser registers the pinned value.
    // eslint-disable-next-line no-unused-expressions
    content.offsetHeight;
    requestAnimationFrame(function () {
      content.style.maxHeight = '0px';
    });
  }

  function initGroup(group) {
    var header = group.querySelector('.group-header');
    var content = group.querySelector('.group-content');
    if (!header || !content) return;

    if (group.classList.contains('open')) {
      // Wait one frame so layout is final, then pin height for animation.
      requestAnimationFrame(function () {
        content.style.maxHeight = content.scrollHeight + 'px';
      });
    }

    header.addEventListener('click', function () {
      var isOpen = group.classList.contains('open');
      if (isOpen) {
        group.classList.remove('open');
        header.setAttribute('aria-expanded', 'false');
        setClosed(content);
      } else {
        group.classList.add('open');
        header.setAttribute('aria-expanded', 'true');
        setOpen(content, group);
      }
    });
  }

  function init(root) {
    var groups = root.querySelectorAll('.specs-group');
    groups.forEach(initGroup);
  }

  function refreshOpen(root) {
    var openContents = root.querySelectorAll('.specs-group.open > .group-content');
    openContents.forEach(function (content) {
      // Reset to natural height so it re-measures on resize / image load.
      content.style.maxHeight = 'none';
      // Then re-pin so future toggles still animate.
      // (No transition will play because we changed the value outside a toggle.)
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(function () {
    document.querySelectorAll('.product-specs').forEach(function (root) {
      init(root);
    });

    // Recalculate open groups on resize (debounced).
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        document.querySelectorAll('.product-specs').forEach(refreshOpen);
      }, 120);
    });

    // When a deferred image inside an open group finishes loading,
    // the height may change — re-measure.
    document.querySelectorAll('.product-specs img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        var group = img.closest('.specs-group');
        if (group && group.classList.contains('open')) {
          var content = group.querySelector('.group-content');
          if (content) content.style.maxHeight = 'none';
        }
      });
    });
  });
})();